import * as React from 'react';

import { cn } from '@/lib/utils/cn';

/** A titled or grouped region within a page. Structure only. */
function Section({ className, ...props }: React.ComponentProps<'section'>) {
  return (
    <section className={cn('flex flex-col gap-4', className)} {...props} />
  );
}

export { Section };
